import React from 'react';
export const WomenDress = ({
  color = 'currentColor',
  width = '18px',
  height = '18px',
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
    >
      <defs>
        <clipPath id='a'>
          <path
            data-name='Rectangle 20'
            transform='translate(226 1073)'
            fill='#ebe7e7'
            d='M0 0h18v18H0z'
          />
        </clipPath>
      </defs>
      <g
        data-name='Women Dress'
        transform='translate(-226 -1073)'
        clipPath='url(#a)'
      >
        <g
          data-name='Group 28'
          transform='translate(230.461 1073)'
          fill={color}
        >
          <path
            data-name='Path 80'
            d='M8.236 12.619c-.12-.6-.384-3.422-1.008-4.358a1.446 1.446 0 01-.19-.8.039.039 0 000-.007c.02-.29.052-.6.073-.762a.493.493 0 01.01-.076c.016-.1.036-.192.057-.289a16.065 16.065 0 00.515-2.746c0-1.429-.733-1.849-.733-1.849.251-1.069.434-1.647.434-1.647L7.179 0A10.558 10.558 0 006.7 1.717a2.911 2.911 0 01-2.161.694 2.913 2.913 0 01-2.161-.694A10.578 10.578 0 001.897 0l-.216.087s.18.577.434 1.647c0 0-.733.421-.733 1.849a14.672 14.672 0 00.491 2.631.1.1 0 000 .039.2.2 0 00.01.035l.007.028c.03.123.074.347.081.347.014.087.029.243.043.4.006.055.01.109.014.163l.016.207h-.007a1.462 1.462 0 01-.191.826c-.624.936-.889 3.758-1.008 4.358s-.408 2.81-.552 3.459-.288 1.537-.288 1.537a3.7 3.7 0 001.2.144s-.087.252.649.18a14.433 14.433 0 011.969-.06c.5.024.153.12.72.12s.216-.1.72-.12a14.388 14.388 0 011.969.06c.733.072.649-.18.649-.18a3.708 3.708 0 001.2-.144s-.144-.889-.289-1.537-.428-2.857-.549-3.457zM6.955 6.468c-.056.077-.106.2-.041.251-.017.115-.027.231-.039.347-.065-.075-.274-.006-.274-.006-.155-.068.137.335.254.181-.005.065-.007.13-.01.2-.142-.01-.284-.02-.427-.028a.66.66 0 00-.068-.149c.016-.108-.108.016-.15.137a25.847 25.847 0 00-.925-.02C5.211 7.304 5 7.373 5 7.373c-.031-.014-.044-.008-.044.009h-.032a.147.147 0 00.016-.067.152.152 0 00-.3 0 .149.149 0 00.017.067c-.406 0-.812.013-1.214.023a.791.791 0 00-.042-.077c.014-.092-.074-.017-.126.081l-.207.005a.491.491 0 00.112-.2c.154-.1-.434-.074-.271.151a.2.2 0 00.051.051h-.173a.087.087 0 000-.122c-.136-.2-.238.094-.25.127l-.3.006a.43.43 0 00-.005-.081c.073-.011.315-.308.087-.354a.173.173 0 00-.109.005 4.818 4.818 0 00-.048-.385.674.674 0 00.059-.135c.067-.042-.005-.062-.1-.051a2.26 2.26 0 00-.039-.147h.224a.152.152 0 10.292.057.148.148 0 00-.014-.062l1.04-.019a.1.1 0 000 .132c.143.2.244-.072.266-.137l.479-.005c.075.095.22.2.277.043a.207.207 0 00.009-.046h.7a.15.15 0 00-.034.092.152.152 0 10.3 0 .149.149 0 00-.033-.087c.384.007.766.024 1.148.048-.116.015-.254.077-.166.2.161.225.271-.151.271-.151.029-.018.032-.032.018-.042l.1.007a.042.042 0 00.009.008c-.007.052-.016.1-.026.153z'
          />
          <path
            data-name='Path 81'
            d='M4.951 7.161c-.144.087.4.076.252-.134s-.252.134-.252.134z'
          />
          <path
            data-name='Path 82'
            d='M4.286 7.052c-.1.235.249.14.249.14.15.075-.149-.375-.249-.14z'
          />
          <path
            data-name='Path 83'
            d='M4.768 6.721c-.284-.057-.1.31-.1.31-.049.19.384-.249.1-.31z'
          />
          <path
            data-name='Path 84'
            d='M5.973 6.533c.095-.26-.277-.138-.277-.138-.167-.073.183.398.277.138z'
          />
          <path
            data-name='Path 85'
            d='M5.382 6.898c.276.023.061-.3.061-.3.027-.184-.34.279-.061.3z'
          />
          <path
            data-name='Path 86'
            d='M4.985 6.632c.161.225.271-.151.271-.151.154-.097-.433-.076-.271.151z'
          />
          <circle
            data-name='Ellipse 3'
            cx='.152'
            cy='.152'
            r='.152'
            transform='translate(3.253 6.916)'
          />
          <path
            data-name='Path 87'
            d='M3.851 6.782c-.144-.21-.252.134-.252.134-.144.086.396.076.252-.134z'
          />
          <path
            data-name='Path 88'
            d='M3.649 7.126c-.167-.073.183.4.277.138s-.277-.138-.277-.138z'
          />
          <path
            data-name='Path 89'
            d='M2.903 6.808c-.1.235.249.14.249.14.151.075-.149-.374-.249-.14z'
          />
          <path
            data-name='Path 90'
            d='M3.384 6.48c-.284-.057-.1.31-.1.31-.046.185.385-.256.1-.31z'
          />
          <path
            data-name='Path 91'
            d='M6.359 6.852a.152.152 0 11-.152.152.152.152 0 01.152-.152z'
          />
          <path
            data-name='Path 92'
            d='M6.553 6.853c-.144.087.4.076.252-.134s-.252.134-.252.134z'
          />
          <path
            data-name='Path 93'
            d='M5.861 7.3c.161.225.271-.151.271-.151.152-.1-.435-.074-.271.151z'
          />
          <path
            data-name='Path 94'
            d='M5.856 6.744c-.1.235.249.14.249.14.15.075-.15-.375-.249-.14z'
          />
          <path
            data-name='Path 95'
            d='M6.338 6.413c-.284-.057-.1.31-.1.31-.049.187.385-.25.1-.31z'
          />
          <path
            data-name='Path 96'
            d='M4.064 6.654c.276.023.061-.3.061-.3.027-.184-.339.276-.061.3z'
          />
          <path
            data-name='Path 97'
            d='M2.972 6.533c.094-.26-.277-.138-.277-.138-.168-.073.182.398.277.138z'
          />
          <path
            data-name='Path 98'
            d='M2.381 6.898c.276.023.061-.3.061-.3.026-.184-.336.279-.061.3z'
          />
        </g>
      </g>
    </svg>
  );
};
